var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { OptionCardGroupCore } from '@core-front/option-card-group';
import Carousel, { CarouselItem } from '@telia-front/carousel';
import { default as Grid, GridColumn } from '@telia-front/grid';
import Notice from '@telia-front/notice';
import OptionCard from '@telia-front/option-card';
const OptionCardGroup = (props) => {
    const isOptionCard = (child) => {
        return child.type === OptionCard;
    };
    const { padding, grid, gridColumn, helper, background, type } = props, rest = __rest(props, ["padding", "grid", "gridColumn", "helper", "background", "type"]);
    return (React.createElement(OptionCardGroupCore, Object.assign({}, rest, { helper: helper, components: {
            Carousel,
            CarouselItem,
            // useCallbacks fix rerendering issue when option card gets controlled outside
            Grid: React.useCallback(gridProps => React.createElement(Grid, Object.assign({}, gridProps, grid)), [grid]),
            GridColumn: React.useCallback(gridColumnProps => React.createElement(GridColumn, Object.assign({}, gridColumnProps, gridColumn)), [gridColumn]),
            Notice: React.useCallback(noticeProps => React.createElement(Notice, Object.assign({}, noticeProps, helper)), [helper]),
            OptionCard: React.useCallback((optionCardProps) => (React.createElement(OptionCard, Object.assign({}, optionCardProps, { background: background, type: type, padding: optionCardProps.padding || padding }))), [type, background, padding]),
        }, isOptionCard: isOptionCard })));
};
export { OptionCardGroup as default };
